<script lang="ts">
    import { SHIELD_IMAGE } from './constants/loginImage';
    import { MODULE_ENUM } from './enums/loginModule';
    import { currentModule } from './store/loginFlow';

    import webp from '@/actions/webp';
</script>

<div class="safe-perception">
    {#if $currentModule === MODULE_ENUM.PICTURE}
        <div class="text">Verificación de seguridad</div>
    {:else}
        <div class="text">¡Datos personales protegidos!</div>
        <div class="text">DiDi Préstamos regulado por PROFECO</div>
    {/if}
    <div class="icon" use:webp={SHIELD_IMAGE}></div>
</div>

<style lang="scss">
    .safe-perception {
        width: 7.1rem;
        height: 0.96rem;
        border-radius: 0.24rem;
        background: #edf0ff;
        position: relative;
        margin: 0.2rem auto 0;
        padding: 0.16rem 0.32rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;

        .text {
            font-family: DiDiSans-Pro-Medium;
            font-size: 0.24rem;
            line-height: 0.32rem;
            color: #3355ff;
        }

        .icon {
            position: absolute;
            z-index: 1;
            right: 0;
            bottom: 0;
            width: 1.65rem;
            height: 0.81rem;
            background-size: 100% 100%;
        }
    }
</style>
